// src/screens/student/mystudygroups/MyStudyGroups.js
import React, { useContext, useEffect, useState } from "react";
import "../../../assets/css/student/mystudygroups/MyStudyGroups.css";
import StudentLayout from "../../../layouts/student/studentlayout/StudentLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import SingleStudyGroupCard from "../../../components/student/StudyGroup/SingleStudyGroupCard";
import { Row } from "react-bootstrap";

const MyStudyGroups = () => {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const { selectedStudyGroupScreenName, loggedInStudent, baseUrl } = useContext(AppContext);
  const chstudent_id = loggedInStudent?.id;
  const [name, setName] = useState();
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [description, setDescription] = useState();
  const [isPublic, setIsPublic] = useState();
  const [maxMembers, setmaxMembers] = useState();
  const [groups, setGroups] = useState([]);

  const createStudyGroups = () => {
    const formData = new FormData();
    formData.append("chstudent_id", chstudent_id);
    formData.append("groupName", name);
    formData.append("subjectName", selectedSubject);
    formData.append("description", description);
    formData.append("maximumMembers", maxMembers);

    axios
      .post(`${baseUrl}/student/studygroup/createStudyGroup`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        setShowCreateModal(false);
        console.log(response.data);
        viewAllStudyGroups();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllStudyGroups = () => {
    const formData = new FormData();
    formData.append("chstudent_id",loggedInStudent.id);

    axios.post(`${baseUrl}/student/studygroup/viewAllStudyGroups`,formData,{
      headers:{
        "Content-Type":"multipart/form-data"
      }
    })
      .then((res) => {
        console.log(res.data);
        setGroups(res.data.studygroups);
      })
      .catch((err) => console.log(err));
  };
  const handleDeleteGroup = (groupId) => {
    if (window.confirm("Are you sure you want to delete this group?")) {
      axios.post(`${baseUrl}/student/studygroup/delete`, { id: groupId })
        .then((res) => {
          if (res.data.success) {
            // alert(res.data.message);
            viewAllStudyGroups(); // refresh list after delete
          } else {
            alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const viewAllSubjects = () => {
    axios
      .post(`${baseUrl}/student/subject/viewAllSubjects`)
      .then((response) => {
        setSubjects(response.data.subjects);

      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleCreateGroup = (e) => {
    e.preventDefault();
    createStudyGroups();
  };
  useEffect(() => {
    viewAllSubjects();
    viewAllStudyGroups();
  }, [loggedInStudent]);

  return (
    <StudentLayout>
      <div className="my-study-groups">
        {/* Header */}
        <div className="page-header">
          <div className="page-title-section">
            <div className="page-title-icon">👥</div>
            <div>
              <h1 className="page-title">My Study Groups</h1>
              <p className="page-description">Manage your study groups</p>
            </div>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => setShowCreateModal(true)}
          >
            <span>➕</span>
            Create New Group
          </button>
        </div>
        {/* Stats (Only My Groups and Upcoming Sessions) */}
        <div className="groups-stats">
          <div className="stat-item">
            <div className="stat-icon">👥</div>
            <div>
              <div className="stat-value">{groups.length}</div>
              <div className="stat-label">My Groups</div>
            </div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">📅</div>
            <div>
              <div className="stat-value">{5}</div>
              <div className="stat-label">Upcoming Sessions</div>
            </div>
          </div>
        </div>

        {/* My Groups Grid */}
        <Row>
          {groups.map((group) => (
            <SingleStudyGroupCard group={group}
              handleDeleteGroup={handleDeleteGroup}
            />
          ))}
        </Row>
        {/* <StudyGroups myGroups={groups} 
        onDelete={handleDeleteGroup} 
        /> */}

        {/* Create Group Modal */}
        {showCreateModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowCreateModal(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Create New Study Group</h2>
                <button
                  className="modal-close"
                  onClick={() => setShowCreateModal(false)}
                >
                  ✕
                </button>
              </div>

              <form onSubmit={handleCreateGroup} className="create-group-form">
                <div className="form-group">
                  <label>Group Name *</label>
                  <input
                    type="text"
                    placeholder="e.g., React Study Group"
                    value={name}
                    onChange={(e) =>
                      setName(e.target.value)
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Subject *</label>
                  <select
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                  >
                    <option value="">Select Subject</option>

                    {subjects.map((singleSubject) => (
                      <option key={singleSubject.id} value={singleSubject.id}>
                        {singleSubject.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Description *</label>
                  <textarea
                    placeholder="Describe your study group..."
                    value={description}
                    onChange={(e) =>
                      setDescription(e.target.value)
                    }
                    rows="4"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Maximum Members</label>
                  <input
                    type="number"
                    value={maxMembers}
                    onChange={(e) =>
                      setmaxMembers(e.target.value)
                    }
                    min="5"
                    max="100"
                  />
                </div>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={() => setShowCreateModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Create Group
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </StudentLayout>
  );
};

export default MyStudyGroups;
